/* eslint-disable react/no-danger */
/* eslint-disable no-return-assign */
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { FaLock, FaLockOpen, FaPlay, FaStop } from 'react-icons/fa';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import qs from 'query-string';
import { format, parseISO, isToday } from 'date-fns';

import { Button, Row, Col, Container } from 'react-bootstrap';

import { useRouteMatch } from 'react-router';

import Loading from '../../components/Loading';
import Timer from '../../components/Timer';
import api from '../../services/api';
import {
  formataCPF,
  formataIdade,
  formataTelefone,
  htmlDecode,
  STATUS_AGENDA,
} from '../../utils/funcoes';
import EditorTexto from '../../components/EditorTexto';

import { Titulo } from './styles';

import { useToast } from '../../hooks/toast';
import { useClinica } from '../../hooks/clinica';
import PacienteCabecalho from '../../components/PacienteCabecalho';
import { IPaciente } from '../../components/Agendamento';
import Historico from '../../components/Historico';
import { IProcedimentoAgendamentoAlvaro } from '../PacienteAtendimentoAlvaro';
import getResponseErrors from '../../utils/getResponseErrors';
import PacienteDocumento from '../../components/PacienteDocumento';
import PedidosExames from './PedidoExames';
import Odonto from './Odonto';
import { useAuth } from '../../hooks/auth';
import PacienteAnexo from '../../components/PacienteAnexo';
import PedidoEncaminhamento from './PedidoEncaminhamento';

interface IUrlParams {
  id: string;
}

export interface IPacienteCodigo extends IPaciente {
  PacCodigo: number;
}

interface IAtendimento {
  AteCodigo?: number;
  AteUsuCodigo?: number;
  AteAgeCodigo: number;
  AteInicio: Date;
  AteFim?: Date;
  AteRestrito: boolean;
  AteTexto: string;
}

const PacienteAtendimento: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  function useQuery(): URLSearchParams {
    return new URLSearchParams(location.search);
  }

  const query = useQuery();
  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;
  const { addToast } = useToast();
  const { imagensClinica } = useClinica();
  const { user } = useAuth();

  const semFoto =
    imagensClinica.find(img => img.nome === 'semFoto')?.arquivo_url || '';

  const formRefTexto = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [ageObsMedico, setAgeObsMedico] = useState<string | undefined>(
    undefined,
  );
  const [ageClinica, setAgeClinica] = useState<number | undefined>(undefined);
  const [ageTratamento, setAgeTratamento] = useState<number | undefined>(
    undefined,
  );

  const [ageTipo, setAgeTipo] = useState<number | undefined>(undefined);
  const [agePlano, setAgePlano] = useState<boolean>(false);
  const [tratamento, setTratamento] = useState<boolean>(false);

  const [paciente, setPaciente] = useState<IPacienteCodigo | undefined>(
    undefined,
  );

  const [procedimentos, setProcedimentos] = useState<
    IProcedimentoAgendamentoAlvaro[]
  >([]);

  const [atendimento, setAtendimento] = useState<IAtendimento | undefined>(
    undefined,
  );
  const [podeAtender, setPodeAtender] = useState<boolean>(false);

  const [botaoAtivo, setBotaoAtivo] = useState('historico');
  const [acessoRestrito, setAcessoRestrito] = useState<boolean>(false);

  const emAtendimento = useMemo(() => {
    return atendimento && atendimento.AteCodigo && atendimento.AteCodigo > 0;
  }, [atendimento]);

  const ehDeHoje = useMemo(() => {
    return (
      atendimento &&
      atendimento.AteInicio &&
      isToday(parseISO(atendimento.AteInicio.toString()))
    );
  }, [atendimento]);

  const dataInicial = useMemo(() => {
    try {
      if (atendimento) {
        const dtIni = format(
          parseISO(atendimento.AteInicio.toString()),
          'yyyy-MM-dd HH:mm:ss',
        );
        return dtIni;
      }
    } catch (error) {
      console.log(error);
    }
    return format(new Date(), 'yyyy-MM-dd HH:mm:ss');
  }, [atendimento]);

  const codigoAgenda = useMemo(() => {
    return query.get('agenda') || undefined;
  }, [query]);

  const dataAgenda = useMemo(() => {
    return query.get('data') || undefined;
  }, [query]);
  const somenteLista = useMemo(() => {
    return query.get('somenteLista') === 'true';
  }, [query]);

  const convenio = useMemo(() => {
    return query.get('convenio') || undefined;
  }, [query]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get(
          `/atendimentos/${id}/detalhe?ConIntegracao=0`,
        );

        if (response.data) {
          setAgeObsMedico(response.data.AgeObsMedico);
          setAgeClinica(response.data.AgeClinica);
          setAgeTratamento(response.data.AgeTratamento);
          setAgeTipo(response.data.AgeTipo);
          if (response.data.AgeTratamento > 0) setBotaoAtivo('tratamento');
          setTratamento(
            (response.data.agenda?.ConTratamento &&
              response.data.AgeTipo === 3) ||
              false,
          );
          setAgePlano(response.data.AgePlano);
          setPaciente({
            ...response.data.paciente,
            PacCodigo: response.data.AgePacCodigo,
            PacTelefone: formataTelefone(response.data.paciente.PacTelefone),
            PacCelular: formataTelefone(response.data.paciente.PacCelular),
            PacCPF: formataCPF(response.data.paciente.PacCPF),
            PacDataNascFormatada: format(
              parseISO(response.data.paciente.PacDataNasc),
              'dd/MM/yyyy',
            ),
            PacIdade: formataIdade(
              parseISO(response.data.paciente.PacDataNasc),
            ),
            avatar_url: response.data.paciente.avatar_url || semFoto,
          });

          if (response.data.atendimento) {
            setAtendimento(response.data.atendimento);
            setAcessoRestrito(response.data.atendimento.AteRestrito);
          }

          setProcedimentos(
            response.data.procedimentos.map(
              (pro: IProcedimentoAgendamentoAlvaro) => {
                return {
                  ...pro,
                  ProCodigo: pro.ProCodigo,
                  ProNome: pro.ProNome,
                  ProDuracao: pro.ProDuracao,
                  ProCodigoAlvaro: pro.ProCodigoAlvaro || '',
                  ProValidado: pro.ProCodigoAlvaro !== '' && pro.exameAlvaro,
                  exameAlvaro: pro.exameAlvaro,
                };
              },
            ),
          );

          const valorPodeAtender =
            response.data.AgeStatus <= STATUS_AGENDA.PAGAMENTO_ANTECIPADO &&
            response.data.AgeStatus >= STATUS_AGENDA.AGUARDANDO_ATENDIMENTO;
          setPodeAtender(valorPodeAtender);
          if (!valorPodeAtender)
            addToast({
              type: 'info',
              title: 'Problema no atendimento',
              description:
                'O atendimento deste paciente não pode ser realizado neste momento, volte a lista de paciente e atualize.',
              timeAlive: 100000,
            });
        }
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível buscar o agendamento',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    }
    if (id && Number(id) !== 0) loadDados();
  }, [id, addToast, semFoto]);

  const handleCriarAtendimento = async (): Promise<void> => {
    if (paciente && ageClinica) {
      const criaExame: IAtendimento = {
        AteAgeCodigo: Number(id),
        AteInicio: new Date(),
        AteTexto: '',
        AteRestrito: false,
      };

      try {
        setLoading(true);
        const response = await api.post('atendimentos', criaExame);
        setAtendimento(response.data);
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro ao inserir atendimento',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSalvarDados = useCallback(
    async (dados: IAtendimento) => {
      setLoading(true);
      const { AteCodigo, AteTexto, AteFim } = dados;
      const dadosFormatado = {
        AteTexto,
        AteFim: AteFim || new Date(),
        AteRestrito: acessoRestrito,
      };

      try {
        const response = await api.put(`atendimentos/${AteCodigo}`, {
          ...dadosFormatado,
        });

        setAtendimento(response.data);
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro ao salvar texto',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [acessoRestrito, addToast],
  );

  const handleVoltar = useCallback((): void => {
    const queryParams = qs.parse(location.search);
    history.push({
      pathname: '../agendaatendimento',
      search: qs.stringify({
        ...queryParams,
        data: dataAgenda,
        agenda: codigoAgenda,
        somenteLista,
      }),
    });
  }, [codigoAgenda, location.search, dataAgenda, somenteLista, history]);

  const handleSubmitTexto = useCallback(
    async dadosForm => {
      try {
        if (atendimento && atendimento.AteCodigo) {
          const dados = {
            ...atendimento,
            AteTexto: dadosForm.editortexto,
          };

          await handleSalvarDados(dados);
        }
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro ao salvar texto',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, atendimento, handleSalvarDados],
  );

  const handleFinaliza = useCallback(async () => {
    try {
      if (atendimento && atendimento.AteCodigo) {
        const dados = {
          ...atendimento,
          AteTexto: formRefTexto.current?.getFieldValue('editortexto'),

          AteFim: new Date(),
        };

        await handleSalvarDados(dados);

        handleVoltar();
      }
    } catch (error) {
      const mensagem = getResponseErrors(error);
      addToast({
        type: 'error',
        title: 'Erro ao salvar texto',
        description: mensagem,
      });
    }
  }, [addToast, atendimento, handleVoltar, handleSalvarDados]);

  const handleAlteraAcessoProntuario = useCallback(
    async (restringir: boolean) => {
      setLoading(true);

      try {
        await api.patch(`atendimentos/acesso/${atendimento?.AteCodigo}`, {
          AteRestrito: restringir,
        });
        setAcessoRestrito(restringir);
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro ao salvar permissão de acesso',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, atendimento?.AteCodigo],
  );

  const handleButtonChange = useCallback((botao: string) => {
    setBotaoAtivo(botao);
  }, []);

  return (
    <Container fluid className="pl-0">
      {loading && <Loading backgroundBlack={false} />}

      <Row noGutters>
        <Col sm={0} md={3} lg={2} className="pr-2">
          <div className="bg-white border h-100">
            <h5 className="p-2 text-secondary">Prontuário</h5>
            {emAtendimento && ehDeHoje && (
              <div>
                <small className="text-info">Duração da consulta</small>

                <Timer
                  id={paciente ? Number(paciente.PacCodigo) : 0}
                  key={`timer-${paciente?.PacCodigo}`}
                  textId={`timer-${paciente?.PacCodigo}`}
                  dataInicial={dataInicial}
                  limite={30}
                />
              </div>
            )}

            {!emAtendimento && (
              <Button
                type="button"
                variant="success"
                className="mb-1"
                onClick={handleCriarAtendimento}
                disabled={loading || !podeAtender}
              >
                <FaPlay size="12" />
                Iniciar Atendimento
              </Button>
            )}
            {emAtendimento && ehDeHoje && (
              <Button
                type="button"
                variant="danger"
                className="mb-1"
                onClick={handleFinaliza}
                disabled={loading || !podeAtender}
              >
                <FaPlay size="12" />
                Finaliza Atendimento
              </Button>
            )}
            <Button
              type="button"
              variant="outline-info"
              className="mb-1"
              onClick={handleVoltar}
            >
              <FaStop size="12" /> Voltar para lista de pacientes
            </Button>

            <div className="list-group list-group-flush small mt-1">
              <button
                type="button"
                data-toggle="list"
                className="list-group-item list-group-item-action text-info"
                style={{
                  backgroundColor: 'none',
                  fontWeight: botaoAtivo === 'historico' ? 'bold' : 'normal',
                }}
                onClick={() => handleButtonChange('historico')}
                disabled={!podeAtender}
              >
                Histórico
              </button>
              {emAtendimento && (
                <>
                  <button
                    type="button"
                    data-toggle="list"
                    className="list-group-item list-group-item-action text-info"
                    style={{
                      backgroundColor: 'none',
                      fontWeight: botaoAtivo === 'atestado' ? 'bold' : 'normal',
                    }}
                    onClick={() => handleButtonChange('atestado')}
                    disabled={!podeAtender}
                  >
                    Atestados/Receitas
                  </button>
                  <button
                    type="button"
                    data-toggle="list"
                    className="list-group-item list-group-item-action text-info"
                    style={{
                      backgroundColor: 'none',
                      fontWeight: botaoAtivo === 'anexo' ? 'bold' : 'normal',
                    }}
                    onClick={() => handleButtonChange('anexo')}
                    disabled={!podeAtender}
                  >
                    Exames/Anexos
                  </button>
                  <button
                    type="button"
                    data-toggle="list"
                    className="list-group-item list-group-item-action text-info"
                    style={{
                      backgroundColor: 'none',
                      fontWeight: botaoAtivo === 'exames' ? 'bold' : 'normal',
                    }}
                    onClick={() => handleButtonChange('exames')}
                    disabled={!podeAtender}
                  >
                    Pedido de Exames
                  </button>
                  <button
                    type="button"
                    data-toggle="list"
                    className="list-group-item list-group-item-action text-info"
                    style={{
                      backgroundColor: 'none',
                      fontWeight:
                        botaoAtivo === 'encaminhamento' ? 'bold' : 'normal',
                    }}
                    onClick={() => handleButtonChange('encaminhamento')}
                    disabled={!podeAtender}
                  >
                    Pedido de Encaminhamento
                  </button>
                  <button
                    type="button"
                    data-toggle="list"
                    className={`list-group-item list-group-item-action text-info ${
                      !tratamento ? 'd-none' : ''
                    }`}
                    style={{
                      backgroundColor: 'none',
                      fontWeight:
                        botaoAtivo === 'tratamento' ? 'bold' : 'normal',
                    }}
                    onClick={() => handleButtonChange('tratamento')}
                    disabled={!podeAtender}
                  >
                    {ageTratamento && ageTratamento > 0
                      ? 'Tratamento'
                      : 'Orçamento'}
                  </button>
                </>
              )}
            </div>
          </div>
        </Col>
        <Col sm={12} md={9} lg={10}>
          <Titulo className="mb-0">Atendimento {convenio || ''}</Titulo>
          <div className="bg-white border rounded p-2 mt-2">
            {paciente && (
              <PacienteCabecalho
                paciente={paciente}
                pacienteID={paciente.PacCodigo}
                procedimentos={procedimentos}
                idadeCompleta
              />
            )}
          </div>
          {ageObsMedico && ageObsMedico !== '' && (
            <Titulo className="mb-0 text-danger">{`OBSERVAÇÃO: ${ageObsMedico}`}</Titulo>
          )}
          <Row>
            <Col>
              {emAtendimento &&
                ehDeHoje &&
                ageTratamento !== undefined &&
                ageTratamento !== 1 && (
                  <div className="mt-1 mb-2" style={{ minHeight: '350px' }}>
                    <Row>
                      <Col md="6">
                        <Titulo>Prontuário de atendimento</Titulo>
                      </Col>
                      <Col md="6" className="text-right">
                        {acessoRestrito && (
                          <Button
                            type="button"
                            className="bg-danger"
                            onClick={() => handleAlteraAcessoProntuario(false)}
                            disabled={loading || !podeAtender}
                          >
                            <FaLock size={20} /> Restrito
                          </Button>
                        )}
                        {!acessoRestrito && (
                          <Button
                            type="button"
                            className="bg-success"
                            onClick={() => handleAlteraAcessoProntuario(true)}
                            disabled={loading || !podeAtender}
                          >
                            <FaLockOpen size={20} /> Liberado
                          </Button>
                        )}
                      </Col>
                    </Row>
                    <div className="w-100" />

                    <div className="bg-white p-2 border rounded">
                      <Form
                        ref={formRefTexto}
                        initialData={{
                          editortexto: htmlDecode(atendimento?.AteTexto || ''),
                        }}
                        onSubmit={handleSubmitTexto}
                      >
                        <EditorTexto height={300} name="editortexto" />
                        <div className="d-flex w-100 justify-content-end">
                          <Button
                            type="submit"
                            className="bg-success"
                            disabled={loading || !podeAtender}
                          >
                            Salvar
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                )}
              <br />
              <div className="border bg-secondary">
                <div className="p-3">
                  <div className="bg-white">
                    {paciente && botaoAtivo === 'historico' && (
                      <Historico pacCodigo={paciente.PacCodigo} />
                    )}
                    {paciente && botaoAtivo === 'atestado' && (
                      <PacienteDocumento pacCodigo={paciente.PacCodigo} />
                    )}

                    {paciente && botaoAtivo === 'anexo' && (
                      <PacienteAnexo pacCodigo={paciente.PacCodigo} />
                    )}

                    {paciente && botaoAtivo === 'exames' && (
                      <PedidosExames
                        pacCodigo={paciente.PacCodigo}
                        ageCodigo={Number(id) || 0}
                        cliCodigo={ageClinica || 0}
                      />
                    )}
                    {paciente && botaoAtivo === 'encaminhamento' && (
                      <PedidoEncaminhamento
                        pacCodigo={paciente.PacCodigo}
                        ageCodigo={Number(id) || 0}
                        cliCodigo={ageClinica || 0}
                      />
                    )}
                    {paciente && botaoAtivo === 'tratamento' && ageTipo === 3 && (
                      <Odonto
                        paciente={{
                          PacCodigo: paciente.PacCodigo,
                          PacCPF: paciente.PacCPF,
                          PacNome: paciente.PacNome,
                          PacNomeSocial: paciente.PacNomeSocial,
                          PacEmail: paciente.PacEmail,
                        }}
                        dadosAgendamento={{
                          pacienteID: paciente.PacCodigo,
                          agePlano,
                          AgeCodigo: Number(id) || 0,
                        }}
                        medUsuCodigo={user.UsuCodigo}
                        finalizado={false}
                        buscaOutrosMedicos
                        bloqueado={false}
                        agendamentoTratamento={
                          ageTratamento && ageTratamento === 1
                            ? Number(id)
                            : undefined
                        }
                        ehDeHoje={ehDeHoje}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <br /> <br /> <br />
        </Col>
      </Row>
    </Container>
  );
};

export default PacienteAtendimento;
